import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';
import { ServiceRequestService } from 'src/app/services/servicerequest.service';
import { WorkshopJobcardCreateService } from '../../workshop-jobcard-create.service';
import { CollectionsService } from 'src/app/services/collections.service'
import { HubUIModule } from 'src/app/components/ui-components/hub-ui.module';
import moment from 'moment';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-workshop-jobcard-collections-deliveries-details',
  templateUrl: './workshop-jobcard-collections-deliveries-details.component.html',
  styleUrls: ['./workshop-jobcard-collections-deliveries-details.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardCollectionsDeliveriesDetailsComponent {

  @Input() jobcard: any;

  public partner: any = {};
  public countryData: any = {};
  public loading: boolean = false;
  public addressOptions: any = [];
  public addressSearch: string = '';
  public collectionsConfigured = false;
  public collection: any = null;
  public delivery: any = null;
  public collectionAddrssLoading: boolean = false;
  public deliveryAddrssLoading: boolean = false;
  public availableCollectionDates: any = [];
  public unavailableCollectionDates: any = [];
  public availableDeliveryDates: any = [];
  public unavailableDeliveryDates: any = [];
  public collectionTimeSlots: any = [];
  public deliveryTimeSlots: any = [];
  public minDate = new Date();
  public maxDate = new Date();
  public hasCollectionSlots: boolean = true;
  public hasDeliverySlots: boolean = true;
  public partnerCoords = { lat: 0.0, lng: 0.0 };
  public busySaving: boolean = false;

  @ViewChild('datepicker') datepicker: any;
  @ViewChild('timeslotDropdown') timeslotDropdown: any;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
    private collectionsService: CollectionsService,
    private serviceRequest: ServiceRequestService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();
    this.initializeCollection();

    // If we have a persisted job, load freshest collection/delivery info from backend
    if (this.jobcard && (this.jobcard.id)) {
      this.getCollection();
    } else {
      this.collection = {};
      this.delivery = {};
      // Fallback: initialize from any provided draft data
      if (!this.jobcard.collectionsDeliveries) {
        this.jobcard.collectionsDeliveries = {
          allowCollection: true,
          allowDelivery: true
        };
      } else {
        this.collection = this.jobcard.collectionsDeliveries.collectionInfo || {};
        if (this.collection && this.collection.fullAddress && this.collection.scheduleDate) {
          this.collection.scheduleDate = new Date(this.collection.scheduleDate);
          this.getAvailability(
            moment(this.collection.scheduleDate).add(-1, 'month').format('YYYY-MM-DD'),
            false,
            true,
            false
          );
        }
      }
    }
  }

  initializeCollection() {
    this.minDate = new Date();
    this.maxDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );

    var startDate = new Date(
      moment(this.minDate).add('year', -1).format('YYYY-MM-DD'),
    );
    var endDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );
    while (startDate <= endDate) {
      var d = new Date(startDate);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      this.unavailableCollectionDates.push(d);
      this.unavailableDeliveryDates.push(new Date(d));
      startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    }
  }

  toString(object) {
    return JSON.stringify(object, null, 2);
  }

  // Load existing collection/delivery info for this jobcard (replicated from CollectionsTab)
  getCollection() {
    const serviceId = this.jobcard.id;
    if (!serviceId) return;

    this.loading = true;
    this.serviceRequest.getCollectionV2(serviceId).subscribe(
      (res: any) => {
        this.jobcard.allowCollection = res.collection;
        this.jobcard.allowDelivery = res.dropOff;
        this.jobcard.collectionsDeliveries.collected = res.collectionInfo?.statusID == 10 ? true : false;
        this.jobcard.collectionsDeliveries.delivered = res.deliveryInfo?.statusID == 20 ? true : false;
        this.collection = res.collectionInfo
          ? {
            scheduleDate: res.collectionInfo.scheduleDate
              ? moment(res.collectionInfo.scheduleDate).toDate()
              : null,
            fullAddress: { address: res.collectionInfo.fullAddress },
            addressDetails: {
              street_no: '',
              street_address: res.collectionInfo.addressLine2
                ? res.collectionInfo.addressLine2.trim()
                : null,
              city: res.collectionInfo.city,
              country: res.collectionInfo.country,
              postal_code: res.collectionInfo.postalCode,
              latitude: res.collectionInfo.latitude,
              longitude: res.collectionInfo.longitude,
            },
            postalCode: res.collectionInfo.postalCode,
            notes: res.collectionInfo.notes,
            timeSlot: res.collectionInfo.timeSlotLabel
              ? {
                code: 0,
                label: res.collectionInfo.timeSlotLabel,
                deliveryVehicleID: res.collectionInfo.deliveryVehicleID,
                slotStartTime: res.collectionInfo.scheduleTimeSlotStart,
                slotEndTime: res.collectionInfo.scheduleTimeSlotEnd,
              }
              : null,
          }
          : {};

        this.collectionTimeSlots = res.collectionInfo && res.collectionInfo.timeSlotLabel
          ? [
            {
              code: 0,
              label: res.collectionInfo.timeSlotLabel,
              deliveryVehicleID: res.collectionInfo.deliveryVehicleID,
              slotStartTime: res.collectionInfo.scheduleTimeSlotStart,
              slotEndTime: res.collectionInfo.scheduleTimeSlotEnd,
            },
          ]
          : [];

        this.delivery = res.deliveryInfo
          ? {
            scheduleDate: res.deliveryInfo.scheduleDate
              ? moment(res.deliveryInfo.scheduleDate).toDate()
              : null,
            fullAddress: { address: res.deliveryInfo.fullAddress },
            addressDetails: {
              street_no: '',
              street_address: res.deliveryInfo.addressLine2
                ? res.deliveryInfo.addressLine2.trim()
                : null,
              city: res.deliveryInfo.city,
              country: res.deliveryInfo.country,
              postal_code: res.deliveryInfo.postalCode,
              latitude: res.deliveryInfo.latitude,
              longitude: res.deliveryInfo.longitude,
            },
            postalCode: res.deliveryInfo.postalCode,
            notes: res.deliveryInfo.notes,
            timeSlot: res.deliveryInfo.timeSlotLabel
              ? {
                code: 0,
                label: res.deliveryInfo.timeSlotLabel,
                deliveryVehicleID: res.deliveryInfo.deliveryVehicleID,
                slotStartTime: res.deliveryInfo.scheduleTimeSlotStart,
                slotEndTime: res.deliveryInfo.scheduleTimeSlotEnd,
              }
              : null,
          }
          : {};

        this.deliveryTimeSlots = res.deliveryInfo && res.deliveryInfo.timeSlotLabel
          ? [
            {
              code: 0,
              label: res.deliveryInfo.timeSlotLabel,
              deliveryVehicleID: res.deliveryInfo.deliveryVehicleID,
              slotStartTime: res.deliveryInfo.scheduleTimeSlotStart,
              slotEndTime: res.deliveryInfo.scheduleTimeSlotEnd,
            },
          ]
          : [];

        this.partnerCoords = { lat: res.latitude, lng: res.longitude };

        // If we have existing addresses, resolve area and availability
        if (this.collection?.fullAddress?.address) {
          this.collectionAddrssLoading = true;
          this.getLocationFromAddress(this.collection.fullAddress.address, 'COLLECTION', false);
        }
        if (this.delivery?.fullAddress?.address) {
          this.deliveryAddrssLoading = true;
          this.getLocationFromAddress(this.delivery.fullAddress.address, 'DELIVERY', false);
        }

        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  isvalid() {
    if (!this.jobcard.collectionsDeliveries.allowCollection) return true;
    if (this.collection && this.collection.fullAddress && this.collection.addressDetails &&
      this.collection.scheduleDate && this.collection.timeSlot) {
      return true;
    } else {
      return false;
    }

  }
  getAvailability(fromDate: string, reset = true, collection = true, delivery = false) {
    const hasArea = (collection && this.collection?.areaID) || (delivery && this.delivery?.areaID);
    if (hasArea) {
      const data: any = {
        PartnerID: this.helpersService.getPartnerId(),
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate).add('month', 2).endOf('month').format('YYYY-MM-DD'),
        CurrentLocalTime:
          collection && this.collection.scheduleDate && moment(this.collection.scheduleDate).toDate() < moment().toDate()
            ? moment(this.collection.scheduleDate).add(-7, 'day').format('YYYY-MM-DDTHH:mm:ss')
            : moment().format('YYYY-MM-DDTHH:mm:ss'),
        IsCollection: !!collection,
        IsDelivery: !!delivery,
        AreaID: collection ? this.collection.areaID : this.delivery.areaID,
      };
      if (this.jobcard?.selectedServiceTypes?.length) {
        data.ServiceTypes = this.jobcard.selectedServiceTypes.map((i: any) => i.serviceTypeID).join(',');
      }

      let invalidDates = JSON.parse(
        JSON.stringify(collection ? this.unavailableCollectionDates : this.unavailableDeliveryDates)
      );
      invalidDates = invalidDates.map((x: any) => new Date(x));

      this.collectionsService.getCollectionsAvailability(data).subscribe(
        (response: any) => {
          if (response?.availableDates && response.availableDates.length > 0) {
            if (collection) {
              this.availableCollectionDates = response.availableDates;
            } else {
              this.availableDeliveryDates = response.availableDates;
            }

            response.availableDates.forEach((availableDate: any) => {
              const idx = invalidDates
                .map((x: any) => moment(x).format('YYYY-MM-DD'))
                .indexOf(moment(availableDate.availableDate).format('YYYY-MM-DD'));
              if (idx > -1) invalidDates.splice(idx, 1);
            });

            if (collection) {
              this.unavailableCollectionDates = invalidDates;
              if (!reset) this.setBookingDate(reset);
            } else {
              this.unavailableDeliveryDates = invalidDates;
            }
          }

          if (response?.unavailableDates && response.unavailableDates.length > 0) {
            response.unavailableDates.map((x: any) => {
              const d = new Date(x.unavailableDate);
              d.setHours(0, 0, 0, 0);
              const list = collection ? this.unavailableCollectionDates : this.unavailableDeliveryDates;
              const index = list.findIndex((y: any) => y.valueOf() === d.valueOf());
              if (index === -1) list.push(d);
            });
          }

          if (collection) this.collectionAddrssLoading = false;
          if (delivery) this.deliveryAddrssLoading = false;
          this.loading = false;
        },
        () => {
          if (collection) this.collectionAddrssLoading = false;
          if (delivery) this.deliveryAddrssLoading = false;
          this.loading = false;
        }
      );
    } else {
      this.loading = false;
      this.collectionAddrssLoading = false;
      this.deliveryAddrssLoading = false;
    }
  }

  done() {
    if (this.isvalid()) {
      if (this.jobcard.collectionsDeliveries.allowCollection) {
        this.jobcard.collectionsDeliveries.collectionInfo = this.collection;
      } else {
        this.jobcard.collectionsDeliveries.collectionInfo = null;
      }
      this.activeModal.close(this.jobcard);
    }
  }

  searchAddress(address) {
    this.addressSearch = address.query;
    this.collection.googlePlaceID = null;
    this.collectionsService
      .getAddressOptions(
        address.query,
        this.partner.Country === 'GB' && this.addressSearch.length <= 8
          ? 'GB'
          : `${this.partner.Latitude},${this.partner.Longitude}`,
      )
      .subscribe((res) => {
        this.addressOptions = res.predictions.map((x) => {
          return { address: x.description, placeID: x.place_id };
        });
      });
  }

  onSelectAddress(event, type) {
    if (type === 'COLLECTION') {
      this.collectionAddrssLoading = true;
      this.collection.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    } else {
      this.deliveryAddrssLoading = true;
      this.delivery.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    }
  }

  async getAddressPlaceDetails(type, getLocFromAddress = false) {
    if (type === 'COLLECTION') {
      await this.collectionsService
        .getAddressOptions(
          this.collection.fullAddress.address,
          `${this.partner.Latitude},${this.partner.Longitude}`,
        )
        .subscribe((res) => {
          this.collection.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (getLocFromAddress && this.collection.googlePlaceID) {
            this.getLocationFromAddress(
              this.collection.fullAddress.address,
              type,
            );
          }
        });
    } else {
      await this.collectionsService
        .getAddressOptions(
          this.delivery.fullAddress.address,
          `${this.partner.Latitude},${this.partner.Longitude}`,
        )
        .subscribe((res) => {
          this.delivery.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (getLocFromAddress && this.delivery.googlePlaceID) {
            this.getLocationFromAddress(
              this.delivery.fullAddress.address,
              type,
            );
          }
        });
    }
  }

  getLocationFromAddress(address, type, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
        (this.partner.Country === 'GB' && this.addressSearch.length <= 8
          ? ', ' + this.addressSearch + ', UK'
          : ''),
      )
      .subscribe((res) => {
        const data = {
          PartnerID: this.helpersService.getPartnerId(),
          IsCollection: type === 'COLLECTION',
          IsDelivery: type === 'DELIVERY',
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };
        if (type === 'COLLECTION') {
          if (!this.collection.googlePlaceID) {
            this.getAddressPlaceDetails(type, true);
            return;
          }

          this.collectionsService.checkAddressInRange(data).subscribe(
            (addressInfo: any) => {
              if (addressInfo && addressInfo.partnerID == this.helpersService.getPartnerId()) {
                this.collectionsService
                  .getGooglePlaceInfo(this.collection.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.collection.addressOutOfRange = false;
                this.collection.distanceToPartner = addressInfo.distanceToStore;
                this.collection.areaID = addressInfo.areaID;
                this.collection.collectionFee = addressInfo.collectionFee;
                this.collection.deliveryFee = addressInfo.deliveryFee;
                var fromDate = moment(
                  this.collection.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset, true, false);
              } else {
                this.collection.addressOutOfRange = true;
                this.collection.distanceToPartner = -1;
                this.collection.areaID = 0;
                this.collectionAddrssLoading = false;
                this.collection.scheduleDate = null;
                this.collection.timeSlot = null;
                this.collectionTimeSlots = [];
                this.collection.collectionFee = null;
                this.collection.deliveryFee = null;
              }
              //Only open the date picker automatically for a new jobcard, not an existing one
              if (!this.jobcard.id) {
                this.datepicker.focus();
              }
            },
            (err) => {
              this.collection.addressOutOfRange = true;
              this.collection.distanceToPartner = -1;
              this.collection.areaID = 0;
              this.collectionAddrssLoading = false;
              this.collection.scheduleDate = null;
              this.collection.timeSlot = null;
              this.collectionTimeSlots = [];
              this.collection.collectionFee = null;
              this.collection.deliveryFee = null;
            },
          );
        } else {
          if (!this.delivery.googlePlaceID) {
            this.getAddressPlaceDetails(type, true);
            return;
          }

          this.collectionsService.checkAddressInRange(data).subscribe(
            (addressInfo: any) => {
              if (addressInfo && addressInfo.partnerID == this.helpersService.getPartnerId()) {
                this.collectionsService
                  .getGooglePlaceInfo(this.delivery.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.delivery.addressOutOfRange = false;
                this.deliveryAddrssLoading = false;
                this.delivery.distanceToPartner = addressInfo.distanceToStore;
                this.delivery.areaID = addressInfo.areaID;
                this.delivery.collectionFee = addressInfo.collectionFee;
                this.delivery.deliveryFee = addressInfo.deliveryFee;
                var fromDate = moment(this.delivery.scheduleDate || this.minDate).startOf('month').format("YYYY-MM-DD");
                this.getAvailability(fromDate, reset, false, true);
              } else {
                this.delivery.addressOutOfRange = true;
                this.delivery.distanceToPartner = -1;
                this.delivery.areaID = 0;
                this.deliveryAddrssLoading = false;
                this.delivery.scheduleDate = null;
                this.delivery.timeSlot = null;
              }
            },
            (err) => {
              this.delivery.addressOutOfRange = true;
              this.delivery.distanceToPartner = -1;
              this.delivery.areaID = 0;
              this.deliveryAddrssLoading = false;
              this.delivery.scheduleDate = null;
              this.delivery.timeSlot = null;
            },
          );
        }
      });
  }

  setAddressInfo(placeInfo, type) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        if (type === 'COLLECTION') {
          this.collection.addressDetails = addressDetails;
        } else {
          this.delivery.addressDetails = addressDetails;
        }
      }
    }
  }

  // Removed duplicate old getAvailability implementation; using generalized version above.

  setBookingDate(reset = false, type = 'COLLECTION') {
    if (type === 'COLLECTION') {
      this.collection.updatedBookingDate = null;
      this.collectionTimeSlots = [];
      if (this.collection.scheduleDate) {
        if (reset) {
          this.collection.timeSlot = {};
        }

        var selectedDate = this.availableCollectionDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.collection.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.collectionTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label };
          });
          if (this.collectionTimeSlots.length == 1) {
            this.collection.timeSlot = this.collectionTimeSlots[0];
          } else if (
            this.collection &&
            this.collection.timeSlot &&
            this.collection.timeSlot.label
          ) {
            var index = this.collectionTimeSlots.findIndex((x) => {
              return x.label === this.collection.timeSlot.label;
            });
            if (index > -1) {
              this.collection.timeSlot = this.collectionTimeSlots[index];
            }
          }
          if (this.collectionTimeSlots.length > 1) {
            this.timeslotDropdown.focus();
          }

        }
        if (this.scheduleDateLessThanCollection()) {
          this.workshopJobcardCreateService.getAvailableSlots(
            { ...this.jobcard, collectionsDeliveries: { collectionInfo: this.collection } },
            this.jobcard.selectedServiceTypes ? this.jobcard.selectedServiceTypes.map(item => item.serviceTypeID) : [],
            [],
            this.jobcard.technician && this.jobcard.technician > 0 ? true : false,
            true
          ).subscribe(result => {
            this.jobcard.technician = result.jobcard.technician;
            this.jobcard.scheduleDate = new Date(result.jobcard.scheduleDate);
          });
        }
      }
    } else {
      this.delivery.updatedBookingDate = null;
      this.deliveryTimeSlots = [];
      if (this.delivery.scheduleDate) {
        if (reset) {
          this.delivery.timeSlot = {};
        }

        var selectedDate = this.availableDeliveryDates.filter((x) => {
          return (
            moment(x.availableDate).format('YYYY-MM-DD') ===
            moment(this.delivery.scheduleDate).format('YYYY-MM-DD')
          );
        });
        if (selectedDate && selectedDate.length > 0) {
          this.deliveryTimeSlots = selectedDate[0].slots.map((x, index) => {
            return { ...x, code: index + 1, name: x.label, value: x.label };
          });
          if (this.deliveryTimeSlots.length == 1) {
            this.delivery.timeSlot = this.deliveryTimeSlots[0];
          } else if (
            this.delivery &&
            this.delivery.timeSlot &&
            this.delivery.timeSlot.label
          ) {
            var index = this.deliveryTimeSlots.findIndex((x) => {
              return x.label === this.delivery.timeSlot.label;
            });
            if (index > -1) {
              this.delivery.timeSlot = this.deliveryTimeSlots[index];
            }
          }
          if (this.deliveryTimeSlots.length > 1) {
            this.timeslotDropdown.focus();
          }

        }
      }
    }
  }

  scheduleDateLessThanCollection() {
    return (
      moment(this.collection.scheduleDate).startOf('day') >=
      moment(this.jobcard.scheduleDate).startOf('day')
    );
  }


  monthChanged(date, type = 'COLLECTION') {
    if (type === 'COLLECTION') {
      this.collectionTimeSlots = [];
      var fromDate = moment(new Date(date.year, date.month - 1, 1))
        .startOf('month')
        .format('YYYY-MM-DD');
      this.getAvailability(fromDate, false, true, false);
    } else {
      this.deliveryTimeSlots = [];
      var fromDate = moment(new Date(date.year, date.month - 1, 1))
        .startOf('month')
        .format('YYYY-MM-DD');
      this.getAvailability(fromDate, false, false, true);
    }
  }


  selectTimeSlot(timeSlot, type = 'COLLECTION') {
    if (type === 'COLLECTION') {
      this.collection.timeSlot = timeSlot;
    } else {
      this.delivery.timeSlot = timeSlot;
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    if (!this.jobcard) {
      this.done();
    } else {
      this.saveChanges();
    }

  }

  saveChanges() {
    const data = {
      ServiceID: this.jobcard.id,
      Collection: this.jobcard.collectionsDeliveries.allowCollection,
      DropOff: this.jobcard.collectionsDeliveries.allowDelivery,
      Collected: this.jobcard.collectionsDeliveries.collected,
      DroppedOff: this.jobcard.collectionsDeliveries.delivered,
      CollectionInfo:
        this.jobcard.collectionsDeliveries.allowCollection && this.collection && this.collection.scheduleDate
          ? {
            ScheduleDate: moment(this.collection.scheduleDate).format(
              'YYYY-MM-DD',
            ),
            FullAddress: this.collection.fullAddress.address,
            AddressDetails: this.collection.addressDetails,
            TimeSlot: {
              deliveryVehicleID: this.collection.timeSlot.deliveryVehicleID,
              slotStartTime: this.collection.timeSlot.slotStartTime,
              slotEndTime: this.collection.timeSlot.slotEndTime,
            },
            Notes: this.collection.notes,
          }
          : null,
      DeliveryInfo:
        this.jobcard.collectionsDeliveries.allowDelivery &&
          this.delivery &&
          (this.delivery.scheduleDate || !this.jobcard.collectionsDeliveries.allowCollection)
          ? {
            ScheduleDate: this.delivery.scheduleDate
              ? moment(this.delivery.scheduleDate).format('YYYY-MM-DD')
              : null,
            FullAddress: this.delivery.fullAddress.address,
            AddressDetails: this.delivery.addressDetails,
            TimeSlot: this.delivery.timeSlot
              ? {
                deliveryVehicleID: this.delivery.timeSlot.deliveryVehicleID,
                slotStartTime: this.delivery.timeSlot.slotStartTime,
                slotEndTime: this.delivery.timeSlot.slotEndTime,
              }
              : {
                deliveryVehicleID: 0,
                slotStartTime: '00:00:00',
                slotEndTime: '00:00:00',
              },
            Notes: this.delivery.notes,
          }
          : null,
    };

    this.busySaving = true;
    this.collectionsService.updateJobCardCollectionIndo(data).subscribe(
      (res) => {
        this.busySaving = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.collections.collection_saved',
          ),
        });

        this.jobcard.collectionsDeliveries.collectionInfo = {
          fullAddress: this.collection?.fullAddress?.address,
          notes: this.collection?.notes,
          scheduleDate: this.collection?.scheduleDate,
          scheduleTimeSlotEnd: this.collection?.timeSlot?.slotEndTime,
          scheduleTimeSlotStart: this.collection?.timeSlot?.slotStartTime,
          statusID: this.jobcard.collectionsDeliveries?.collected ? 10 : 0,
        }
        this.jobcard.collectionsDeliveries.deliveryInfo = {
          fullAddress: this.delivery?.fullAddress?.address,
          notes: this.delivery?.notes,
          scheduleDate: this.delivery?.scheduleDate,
          scheduleTimeSlotEnd: this.delivery?.timeSlot?.slotEndTime,
          scheduleTimeSlotStart: this.delivery?.timeSlot?.slotStartTime,
          statusID: this.jobcard.collectionsDeliveries?.delivered ? 20 : 0,
        }

        this.activeModal.close(this.jobcard);
      },
      (err) => {
        this.busySaving = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.collections.collection_not_saved',
          ),
        });
      },
    );
  }
}
